import { createSearchQueryAppliedComponent } from '../../shared/filterUtils'
import type { ListingFilter } from '../../types'

const SearchQueryFilter: ListingFilter<string | null> = () => <></>

SearchQueryFilter.expandedOnInit = false
SearchQueryFilter.getOwnProps = ({ state, updateFilters }) => {
  return {
    filterKey: 'q',
    value: state.filters.q,
    onChange: (value: string | null) => updateFilters({ q: value }),
  }
}

SearchQueryFilter.label = 'Filters.searchQuery'

SearchQueryFilter.Applied = createSearchQueryAppliedComponent(
  'q',
  SearchQueryFilter.label
)

export default SearchQueryFilter
